<div class="email-settings">
  <div class="setting-container" *ngIf="emailSettings">
    <div class="message-box">
      <div class="update-error" *ngIf="isUpdateSettingFail">{{'email_setting.errors.api_save_error' | translate}}</div>
      <div class="update-success" *ngIf="isUpdateSettingSuccess">{{'email_setting.update_success' | translate}}</div>
    </div>
    <notification-setting #notificationSetting [notificationSetting]="emailSettings"></notification-setting>
    <div class="action-buttons">
      <button *ngIf="isUpdatingSetting" class="button blue">{{'common.btn.saving' | translate}}</button>
      <button *ngIf="!isUpdatingSetting" class="button blue" (click)="saveSettings()">{{'common.btn.save' | translate}}</button>
    </div>
  </div>
</div>

<achoo-popup #emailSettingError [isSpecialPopup]="true">
  <div class="email-setting-error">
    <h2 class="header">{{'notification.error' | translate}}</h2>
    <p class="message-content" [innerHTML]="errorMessage"></p>
  </div>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/email-settings/email-settings.component.html